import { render } from "./ImportConfig.vue?vue&type=template&id=571e3c78"
import script from "./ImportConfig.vue?vue&type=script&lang=js"
export * from "./ImportConfig.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ThesauRex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__